/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import _ from 'underscore';

import BenchlingConfig from 'BenchlingConfig';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import FileBrowserUtil from 'file-browser/FileBrowserUtil';
import getTestProps from 'test/lib/cypress/getTestProps';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import * as nyc from 'ui-library/NYC';
import fuzzydate from 'util/fuzzydate';

const MAX_FILES = BenchlingConfig.WORKLISTS_ENABLE_WORKLISTS ? 10 : 20;

interface Props {
  emptyText: string;
  files: Array<{
    endAccess?: string;
    id: string;
    name: string;
  }>;
  headerText: string;
  activeItemId?: string | null;
}

class FileSummary extends React.Component<Props> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _openFile = (file: any) => {
    FileBrowserActions.openFile(file.id);
  };

  render(): JSX.Element {
    // Sort files by last modified and only render up to MAX_FILES files.
    const files = _.sortBy(this.props.files, (file) => moment(file.endAccess))
      .reverse()
      .slice(0, MAX_FILES);
    return (
      <nyc.Container size="sidepanel" className="homeSidepanel-today-itemSummary homeSidepanel-file-summary">
        <nyc.Row className="homeSidepanel-today-sectionHeader">
          <div className="homeSidepanel-today-sectionHeader-content">{this.props.headerText}</div>
        </nyc.Row>
        {(() => {
          if (this.props.files.length === 0) {
            return (
              <nyc.Row className="homeSidepanel-today-item">
                <div {...getTestProps({component: 'FileSummary', element: 'noRecentEntityRow'})}>
                  {this.props.emptyText}
                </div>
              </nyc.Row>
            );
          }
          return files.map((file, i) => {
            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
            const handleFileClick = () => {
              this._openFile(file);
            };
            let dateString;
            if (!file.endAccess) {
              dateString = null;
            } else {
              dateString = fuzzydate(file.endAccess, {showYear: false, showWeekday: true, compact: true});
            }
            return (
              <nyc.Row
                className={classNames('homeSidepanel-today-item', {
                  'homeSidepanel-today-item--active': file.id === this.props.activeItemId,
                })}
                key={i}
              >
                <div
                  className="homeSidepanel-today-item-content u-pointer u-flex-display"
                  onClick={handleFileClick}
                >
                  <div className="homeSidepanel-today-item-icon">
                    <BenchlingIcon icon={FileBrowserUtil.getFileIconName(file)} />
                  </div>
                  <div className="homeSidepanel-today-item-title whiteLink">{file.name}</div>
                  <div className="homeSidepanel-today-item-subtitle u-small-spacing-left">{dateString}</div>
                </div>
              </nyc.Row>
            );
          });
        })()}
      </nyc.Container>
    );
  }
}

export default FileSummary;
